import React, { FC, useState } from 'react';
import { Col, Row, Typography, Form, Button } from 'antd';
import BareLayout from 'src/layouts/bare/bare.layout';
import ShadowBox from 'src/components/shadow-box/shadow-box';
import { i18nKey } from 'src/locales/i18n';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { PAGE_ROUTE } from 'src/constants/route';
import styles from './forgot-password.module.less';
import { IAuthStore } from 'src/store/auth/auth.store';
import useStore from 'src/hooks/useStore';
import { HTTP_STATUS_RESPONSE_KEY } from 'src/constants/api';
import InputLowercase from 'src/components/input-with-lowercase/input-with-lowercase';

interface IResponseForgotPassword {
	status: boolean;
	responseKey?: string;
}

const ForgotPasswordPage: FC = () => {
	const [submitting, setSubmitting] = useState(false);
	const [responseKey, setResponseKey] = useState('');
	const [t] = useTranslation();
	const navigator = useNavigate();

	const [form] = Form.useForm();

	const autStore: IAuthStore = useStore('authStore');

	const onFormSubmit = async ({ email }: { email: string }) => {
		setSubmitting(true);
		const rs = await autStore.forgotPassword({ email }) as IResponseForgotPassword;
		if (rs.responseKey && !rs.status) {
			setResponseKey(rs.responseKey)
		}

		setSubmitting(false);
		if (rs.status) {
			navigator(PAGE_ROUTE.FORGOT_PASSWORD_EMAIL);
		}
	};

	return (
		<>
			<BareLayout>
				<Row justify="center" gutter={[32, 32]}>
					<Col xs={24} sm={24} md={24} lg={10}>
						<ShadowBox>
							<Col span={24} className={styles.item}>
								<Typography.Title level={3}>{t(i18nKey.login.formForgotPassword.title)}</Typography.Title>
								<Typography.Text>{t(i18nKey.login.formForgotPassword.subTitle)}</Typography.Text>
							</Col>
							<Form autoComplete="off" layout="vertical" form={form} onFinish={onFormSubmit}>
								<Col span={24} className={styles.item}>
									<Form.Item
										validateStatus={responseKey === HTTP_STATUS_RESPONSE_KEY.USER_DONT_HAVE_PERMISSION ? 'error' : 'success'}
										help={responseKey === HTTP_STATUS_RESPONSE_KEY.USER_DONT_HAVE_PERMISSION ? t(i18nKey.login.formForgotPassword.emailNotExisted) : ''}
									>
										<InputLowercase 
											name="email"
											rules={[{ required: true, message: `${t(i18nKey.onboarding.validation.required)}` }]}
											tabIndex={1}
											onChange={() => { setResponseKey('') }}
											type="text"
											placeholder={`${t(i18nKey.login.formForgotPassword.placeholderInput)}`}
										/>
									</Form.Item>
								</Col>
								<Col span={24}>
									<Button type="primary" block htmlType="submit" loading={submitting}>
										{t(i18nKey.login.formForgotPassword.resetPassword)}
									</Button>
								</Col>
							</Form>
							<Col span={24} className={styles.item}>
								<Link to={PAGE_ROUTE.LOGIN} tabIndex={3}>
									{t(i18nKey.login.formForgotPassword.backToLogin)}
								</Link>
							</Col>
						</ShadowBox>
					</Col>
				</Row>
			</BareLayout>
		</>
	);
};

export default ForgotPasswordPage;
